import React, { useEffect, useRef, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import infoIcon from "../assets/images/infobtnblue.svg";
import PlusPlaceholder from "../assets/images/PlusImage.png";
import Modal from "react-bootstrap/Modal";
import CKeditorComponent from "../component/common-component/CKeditorComponent";
import { commonservices } from "../services/CommonServices";
import { apiCall } from "../services/AxiosService";
import { API_URL } from "../services/APIRoute";
import { apiResponse } from "../services/APIResponse";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { userInfo } from "../services/ReduxTookit/UserInfoSlice";
import redalert from "../assets/images/redalert.svg";
import annualsummary from "../assets/images/My_machine.svg";
import DemoLogo from "../assets/images/quantummain.svg";
import {
  DeprecateMachine,
  DiscontinueMachine,
} from "../services/ReduxTookit/Slice/MachineRedux";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

const MachineModal = (props) => {
  let dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);
  const [input, setInput] = useState({
    machineid: "",
    versionnumber: "",
    isdeprecated: true,
    deprecateddate: "",
    deprecatedreason: "",
    errors: {
      machineid: "",
      versionnumber: "",
      isdeprecated: true,
      deprecateddate: "",
      deprecatedreason: "",
      ValidationRules: [
        {
          FieldName: "deprecateddate",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "deprecatedreason",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  useEffect(() => {
    if (props?.data) {
      setInput({
        ...input,
        machineid: props?.data?.machineid,
        versionnumber: props?.data?.versionnumber,
      });
    }
  }, [props?.data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setLoading(true);
      let body;
      let URL;
      if (props?.type === "Discontinue") {
        body = {
          machineid: input?.machineid,
          versionnumber: input?.versionnumber,
          usersuggestdate: input?.deprecateddate,
          userreason: input?.deprecatedreason,
          requesttype: "Discontinue",
        };
        // URL = API_URL.BASEURL + API_URL.DISCONTINUE_MACHINE;
        // let resData = await apiCall(
        //   {
        //     method: "PUT",
        //     url: URL,
        //     body: body,
        //   },
        //   true
        // );

        // let response = apiResponse(true, resData, setLoading);
        dispatch(DiscontinueMachine(body))?.then((response) => {
          if (response?.payload?.isValidate) {
            props.onHide();
            props.bindlist();
          }

          if (!response?.payload?.isValidate) {
          }
        });
      } else if (props?.type === "Deprecate") {
        body = {
          machineid: input?.machineid,
          versionnumber: input?.versionnumber,
          usersuggestdate: input?.deprecateddate,
          userreason: input?.deprecatedreason,
          requesttype: "Deprecated",
        };
        // URL = API_URL.BASEURL + API_URL.DEPRECATE_MACHINE;
        // let resData = await apiCall(
        //   {
        //     method: "PUT",
        //     url: URL,
        //     body: body,
        //   },
        //   true
        // );

        // let response = apiResponse(true, resData, setLoading);
        dispatch(DeprecateMachine(body))?.then((response) => {
          if (response?.payload?.isValidate) {
            props.onHide();
            props.bindlist();
            setLoading(false);
          }

          if (!response?.payload?.isValidate) {
            setLoading(false);
          }
        });
      }
    }
  };

  const handleCKEditor = (content, tag) => {
    setInput({
      ...input,
      [tag]: content,
    });
  };

  // Add or remove 'loadtime' class based on MachineLoader
  
   useEffect(() => {
    if (Loading) {
      document.body.classList.add('loadtime');
    } 
    // else {
    //   document.body.classList.remove('loadtime');
    // }
  
    // Cleanup when component unmounts
    return () => {
      document.body.classList.remove('loadtime');
    };
  }, [Loading]); // Re-run this effect when MachineLoader changes

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {Loading && <MainpageLoader/>}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="version-discontinue-modal-header">
            <div className="action-title">
              <img src={redalert} alt="alert" />
              <span>Danger Zone</span>
            </div>

            <p> - {props?.type} Machine</p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      >
        <Modal.Body>
          <>
            <div className="mb-3 version-discontinue-modal-title-container">
              <div className="version-discontinue-modal-title-img">
                <img
                  src={
                    props?.machineDetail?.logo
                      ? props?.machineDetail?.logo
                      : DemoLogo
                  }
                  alt="annualsummary"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = DemoLogo;
                  }}
                />
              </div>
              <p className="version-discontinue-modal-title-machine-name">
                {props?.machineDetail?.name}
              </p>
            </div>
            <Col xl={12} className="mb-3">
              <Row>
                <Col xl={6}>
                  <Form.Group className="form-group">
                    <Form.Label className="login-label">
                      Version<span className="ms-1 red-color-text">*</span>
                    </Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        className="common-input"
                        value={props?.machineDetail?.version}
                        disabled
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col xl={6}>
                  <Form.Group className="form-group">
                    <Form.Label className="login-label">
                      {props?.type} From
                      <span className="ms-1 red-color-text">*</span>
                    </Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="date"
                        // min={
                        //   new Date(
                        //     new Date().setMonth(new Date().getMonth() + 2)
                        //   )
                        //     .toISOString()
                        //     .split("T")[0]
                        // }
                        min={
                          new Date(
                            new Date().setMonth(new Date().getMonth() + 2) +
                              86400000
                          )
                            .toISOString()
                            .split("T")[0]
                        }
                        className="common-input"
                        value={input.deprecateddate}
                        onChange={(e) =>
                          setInput({
                            ...input,
                            deprecateddate: e.target.value,
                          })
                        }
                        isInvalid={input?.errors?.deprecateddate}
                      />
                      {input.errors.deprecateddate && (
                        <Form.Control.Feedback type="invalid">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.deprecateddate}
                            />
                          </span>
                        </Form.Control.Feedback>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Col>

            <Form.Group className="mb-3" controlId="formProfilePic">
              <Form.Label className="common-label">
                {`Reason for ${props?.type} Machine`}
                <span className="ms-1 red-color-text">*</span>
              </Form.Label>
              <div className="position-relative">
                <div
                  className={`${
                    input.errors.deprecatedreason && "error-border-line"
                  }`}
                >
                  <CKeditorComponent
                    onChange={handleCKEditor}
                    tag="deprecatedreason"
                    value={input.deprecatedreason}
                  />
                </div>
                {input.errors.deprecatedreason && (
                  <p className="error-line">
                    <span className="error-message-icon">
                      <img
                        src={infoIcon}
                        alt="infoIcon"
                        title={input.errors.deprecatedreason}
                      />
                    </span>
                  </p>
                )}
              </div>
            </Form.Group>
          </>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="grey-btn w-auto"
            type="reset"
            onClick={props.onHide}
          >
            Cancel
          </button>
          <button disabled={Loading} className="blue-btn w-auto" type="submit">
            {Loading ? (
              // <>
              //   <span>Loading</span>{" "}
              //   <Spinner
              //     className="ms-1"
              //     animation="border"
              //     role="status"
              //     size="sm"
              //   >
              //     <span className="visually-hidden">Loading...</span>
              //   </Spinner>
              // </>
              <SubmitLoading />
            ) : (
              "Submit"
            )}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default MachineModal;
